import { render, staticRenderFns } from "./selectRegionPanel.vue?vue&type=template&id=7974d23b&scoped=true&"
import script from "./selectRegionPanel.vue?vue&type=script&lang=js&"
export * from "./selectRegionPanel.vue?vue&type=script&lang=js&"
import style0 from "./selectRegionPanel.vue?vue&type=style&index=0&id=7974d23b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7974d23b",
  null
  
)

export default component.exports